/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as VenueSlugRouteImport } from './routes/$venueSlug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VenueSlugIndexRouteImport } from './routes/$venueSlug/index'
import { Route as AuthAuthVenueSlugIndexRouteImport } from './routes/_auth/auth/$venueSlug/index'
import { Route as AuthAuthTokenEmailTokenRouteImport } from './routes/_auth/auth/token.$email.$token'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const VenueSlugRoute = VenueSlugRouteImport.update({
  id: '/$venueSlug',
  path: '/$venueSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VenueSlugIndexRoute = VenueSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VenueSlugRoute,
} as any)
const AuthAuthVenueSlugIndexRoute = AuthAuthVenueSlugIndexRouteImport.update({
  id: '/auth/$venueSlug/',
  path: '/auth/$venueSlug/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthTokenEmailTokenRoute = AuthAuthTokenEmailTokenRouteImport.update({
  id: '/auth/token/$email/$token',
  path: '/auth/token/$email/$token',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$venueSlug': typeof VenueSlugRouteWithChildren
  '/$venueSlug/': typeof VenueSlugIndexRoute
  '/auth/$venueSlug/': typeof AuthAuthVenueSlugIndexRoute
  '/auth/token/$email/$token': typeof AuthAuthTokenEmailTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$venueSlug': typeof VenueSlugIndexRoute
  '/auth/$venueSlug': typeof AuthAuthVenueSlugIndexRoute
  '/auth/token/$email/$token': typeof AuthAuthTokenEmailTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$venueSlug': typeof VenueSlugRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/$venueSlug/': typeof VenueSlugIndexRoute
  '/_auth/auth/$venueSlug/': typeof AuthAuthVenueSlugIndexRoute
  '/_auth/auth/token/$email/$token': typeof AuthAuthTokenEmailTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$venueSlug'
    | '/$venueSlug/'
    | '/auth/$venueSlug/'
    | '/auth/token/$email/$token'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$venueSlug' | '/auth/$venueSlug' | '/auth/token/$email/$token'
  id:
    | '__root__'
    | '/'
    | '/$venueSlug'
    | '/_auth'
    | '/$venueSlug/'
    | '/_auth/auth/$venueSlug/'
    | '/_auth/auth/token/$email/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  VenueSlugRoute: typeof VenueSlugRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$venueSlug': {
      id: '/$venueSlug'
      path: '/$venueSlug'
      fullPath: '/$venueSlug'
      preLoaderRoute: typeof VenueSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$venueSlug/': {
      id: '/$venueSlug/'
      path: '/'
      fullPath: '/$venueSlug/'
      preLoaderRoute: typeof VenueSlugIndexRouteImport
      parentRoute: typeof VenueSlugRoute
    }
    '/_auth/auth/$venueSlug/': {
      id: '/_auth/auth/$venueSlug/'
      path: '/auth/$venueSlug'
      fullPath: '/auth/$venueSlug/'
      preLoaderRoute: typeof AuthAuthVenueSlugIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/token/$email/$token': {
      id: '/_auth/auth/token/$email/$token'
      path: '/auth/token/$email/$token'
      fullPath: '/auth/token/$email/$token'
      preLoaderRoute: typeof AuthAuthTokenEmailTokenRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface VenueSlugRouteChildren {
  VenueSlugIndexRoute: typeof VenueSlugIndexRoute
}

const VenueSlugRouteChildren: VenueSlugRouteChildren = {
  VenueSlugIndexRoute: VenueSlugIndexRoute,
}

const VenueSlugRouteWithChildren = VenueSlugRoute._addFileChildren(
  VenueSlugRouteChildren,
)

interface AuthRouteChildren {
  AuthAuthVenueSlugIndexRoute: typeof AuthAuthVenueSlugIndexRoute
  AuthAuthTokenEmailTokenRoute: typeof AuthAuthTokenEmailTokenRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAuthVenueSlugIndexRoute: AuthAuthVenueSlugIndexRoute,
  AuthAuthTokenEmailTokenRoute: AuthAuthTokenEmailTokenRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  VenueSlugRoute: VenueSlugRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
